import { Component, inject, signal } from '@angular/core';
import { CommonModule, ViewportScroller } from '@angular/common';
import { AuthService } from '@auth0/auth0-angular';
import { AuthzService } from '../../../core/auth/authz.service';
import { AuthFacade } from '../../../core/auth/auth.facade';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { ROUTER_TOKENS } from '../../../app.routes';
//Service
import { LoggingService } from '../../../core/utils/logging.service';
// RxJS
import { timer } from 'rxjs';
// PrimeNG
import { ButtonModule } from 'primeng/button';
import { ProdAndRcHiddenElementDirective } from '../../../core/directive/prod-and-rc-hidden-element.directive';
import { ProdHiddenElementDirective } from '../../../core/directive/prod-hidden-element.directive';

export interface ILandingMenu {
  name: string;
  pathId: string;
}

@Component({
  selector: 'app-landing-layout-dev',
  imports: [CommonModule, ButtonModule],
  templateUrl: './landing-layout-dev.component.html',
  styleUrl: './landing-layout-dev.component.scss',
})
export class LandingLayoutDevComponent {
  private readonly router = inject(Router);
  private readonly auth0 = inject(AuthService);
  protected readonly authz = inject(AuthzService);
  protected readonly authFacade = inject(AuthFacade);
  private readonly loggingService = inject(LoggingService);
  private readonly viewportScroller = inject(ViewportScroller);

  isDev = environment.phase === 'dev' || environment.phase === 'local';
  currentMenu = signal<any>('#Home');

  constructor() {
    // Fix Path Empty
    this.router.navigate([`/`]);

    // viewportScroller navbar
    timer(100).subscribe(() => {
      this.viewportScroller.scrollToPosition([0, 0]);
    });
  }

  handleLogin() {
    this.authz.login();
  }

  handleRedirectToChooseCompany() {
    this.loggingService.error('###handleRedirect');
    this.router.navigate(['/choose-company']);
  }

  async handleRegister() {
    await this.router.navigate([`/${ROUTER_TOKENS.REGISTER}`]);
  }

  // handleLogout() {
  //   this.authz.logout();
  // }

  // Force login
  // handleAuthCallback() {
  //   this.router.navigate([`/${ROUTER_TOKENS.AUTH_CALLBACK}`]);
  // }

  //!SECTION - For Landing Menu
  onChangeLandingMunuId(pathName: any) {
    this.currentMenu.set(pathName);
    // Set Scroll Behavior
    document.getElementById(this.currentMenu())?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }

  landingMenuList: ILandingMenu[] = [
    {
      name: 'Menu1',
      pathId: '#section1',
    },
    {
      name: 'Menu2',
      pathId: '#section2',
    },
    {
      name: 'Home',
      pathId: '#Home',
    },
    {
      name: 'Menu3',
      pathId: '#section3',
    },
    {
      name: 'Menu4',
      pathId: '#section4',
    },
  ];
}
